import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-warning',
    templateUrl: './svg.warning.component.html',
    styleUrls: ['./svg.warning.component.scss'],
    standalone: false
})
export class SvgWarningComponent {
}
